//
// # GCP Utilities for IDE
//
// Thin wrapper around CoreUtils GCP log utilities using browser console.
//

import { Context, formatGcpLogMessage, shouldLogApi } from "CoreUtils";

export { gcpLogsUrl } from "CoreUtils";

/**
 * Log a message with a GCP Logs Explorer URL for the context's logId.
 * If no logId is present, does not log anything.
 * @param label - The label to show in brackets, e.g. "IDE"
 * @param api - The API being called, e.g. "prompt", "open", "get-pdk"
 * @param ctx - The Context containing the logId
 * @param timeWindowMinutes - Time window in minutes (+/- from now). Default: 10
 */
export function logWithGcpUrl(
  label: string,
  api: string,
  ctx: Context,
  timeWindowMinutes?: number
): void {
  const message = formatGcpLogMessage(label, api, ctx, timeWindowMinutes);
  if (message) {
    console.log(message);
  }
}

/**
 * Log a message with a GCP Logs Explorer URL, filtering out noisy APIs.
 * Skips logging for APIs in FILTERED_APIS (currently: get-pdk, open, ping).
 * @param label - The label to show in brackets, e.g. "IDE"
 * @param api - The API being called, e.g. "prompt", "open", "get-pdk"
 * @param ctx - The Context containing the logId
 * @param timeWindowMinutes - Time window in minutes (+/- from now). Default: 10
 */
export function logWithGcpUrlFiltered(
  label: string,
  api: string,
  ctx: Context,
  timeWindowMinutes?: number
): void {
  if (shouldLogApi(api)) {
    logWithGcpUrl(label, api, ctx, timeWindowMinutes);
  }
}
